import { useAuthContext } from 'src/auth/hooks';
import {
  getData,
  getDataGuest,
  postData,
  postDataGuest,
  putData,
} from 'src/utils/axios/index';
import { urlMap } from 'src/utils/urls';

export const getOrganizationId = user => {
  try {
    if (user && user.organization_id) {
      return user.organization_id;
    }
  } catch (err) {
    const { logout } = useAuthContext();
    logout().then(d => {
      console.log('user logged out...');
    });
  }
  return null;
};

export const resetTemplateApi = async (payload, org_id) => {
  const url = `${urlMap.resetTemplate}`.replace('{org-id}', org_id);
  return postData(url, payload);
};

export const sendPricingRequest = plan => {
  const url = `${urlMap.sendPricingRequest}`.replace('{plan}', plan);
  return postData(url);
};

export const updateUserDetailsApi = async payload => {
  const url = `${urlMap.updateUserDetails}`;
  return putData(url, payload);
};

export const updateUserPassword = async (payload, token) => {
  const url = `${urlMap.updatePassword}`;
  return putData(url, payload, token);
};

export const forgotPasswordApi = async payload => {
  const url = `${urlMap.forgotPassword}`;
  return postDataGuest(url, payload);
};

export const getOrganizationDetails = async (orgId, token) => {
  const url = `${urlMap.getOrganizationDetails}`.replace('{org-id}', orgId);
  return getData(url, token);
};

export const getPublicOrganizationDetails = async orgId => {
  const url = `${urlMap.publicOrgDetails}`.replace('{org-id}', orgId);
  return getDataGuest(url);
};

export const putOrgDetails = async (payload, org_id) => {
  const url = `${urlMap.orgUpdate}`.replace('{org-id}', org_id);
  // console.log(url);
  return putData(url, payload);
};

export const getOrganizationEmailTemplates = async orgId => {
  const url = `${urlMap.getOrganizationEmailTemplates}`.replace(
    '{org-id}',
    orgId,
  );
  return getData(url);
};

export const updateEmailTemplate = async (payload, org_id) => {
  const url = `${urlMap.updateOrganizationEmailTemplates}`.replace(
    '{org-id}',
    org_id,
  );
  // console.log(url);
  return postData(url, payload);
};

export const getUserDetails = async () => {
  const url = `${urlMap.getUserDetails}`;
  return getData(url);
};

export const getCreditDetails = async orgId => {
  const url = `${urlMap.getCreditDetails}`.replace('{org-id}', orgId);
  return getData(url);
};

export const getUsers = async orgId => {
  const url = `${urlMap.getUsers}`.replace('{org-id}', orgId);
  return getData(url);
};

export const inviteUser = async (payload, orgId) => {
  const url = `${urlMap.inviteUser}`.replace('{org-id}', orgId);
  return postData(url, payload);
};

export const checkInviteUser = async (orgId, userId, token) => {
  const url = `${urlMap.checkInviteUser}`
    .replace('{org-id}', orgId)
    .replace('{user-id}', userId);
  return getData(url, token);
};

export const confirmInviteUser = async (orgId, userId, payload, token) => {
  const url = `${urlMap.confirmInviteUser}`
    .replace('{org-id}', orgId)
    .replace('{user-id}', userId);
  return postData(url, payload, token);
};

export const resendTeamInvite = async (orgId, userId) => {
  const url = `${urlMap.resendTeamInvite}`
    .replace('{org-id}', orgId)
    .replace('{user-id}', userId);
  return getData(url);
};

export const deactivateUser = async (orgId, userId) => {
  const url = `${urlMap.deactivateUser}`
    .replace('{org-id}', orgId)
    .replace('{user-id}', userId);
  return getData(url);
};

export const activateUser = async (orgId, userId) => {
  const url = `${urlMap.activateUser}`
    .replace('{org-id}', orgId)
    .replace('{user-id}', userId);
  return getData(url);
};

export const makeAdmin = async (orgId, userId) => {
  const url = `${urlMap.makeAdmin}`
    .replace('{org-id}', orgId)
    .replace('{user-id}', userId);
  return getData(url);
};

export const getSignupStatus = async token => {
  const url = `${urlMap.checkSignupStatus}`;
  return getData(url,token); 
};

export const signup = async (data,token) => {
  const url= `${urlMap.signup}`;
  return postData(url,data,token);
}

export const getNotificationSettings = async orgId => {
  const url = `${urlMap.getNotificationSettings}`.replace('{org-id}', orgId);
  return getData(url);
};

export const updateNotificationSettings = async (payload, orgId) => {
  const url = `${urlMap.updateNotificationSettings}`.replace('{org-id}', orgId);
  return postData(url, payload);
};
